import React,{useState,useEffect} from 'react'
import axios from 'axios'
import './Tuzilma.css'
import {Link} from 'react-router-dom'
import TeachImg from '../../assets/Tuzilma/teach.png'
import Telegramimg from '../../assets/Tuzilma/Tekegramm.svg'
import InstagramImg from '../../assets/Tuzilma/Instagramm.svg'
import FacebookImg from '../../assets/Tuzilma/Facebook.svg'
import Techimg from '../../assets/Tuzilma/tech.png'
const Tuzilma=()=> {

  const[teach,setTeach]=useState([])
 
   const loadTeach=async()=>{
     const res=await axios.get('https://afternoon-reaches-98033.herokuapp.com/api/teacher')
     setTeach(res.data)
    
   }
useEffect(()=>{
  loadTeach()
},[])

  return (
    <div className='Tuzilma'>
       <div className="Navigator">
       <div className="Navigator__from"><Link to='/'> Home</Link></div>
       <div className="Navigator__line"></div>
       <div className="Navigator__to">Tuzilma</div>
       </div>
       <div className='TuzilmaWrapper'>
       <div className='name'>
          <div className="line5"></div>
          <p className='title'>Mamuriyat</p>
          </div>
          <div className='Mamuriyat'>
           {
             teach.map((item,index)=>{
               return(
                  <Link to={`/teacher/${item.id}` } key={item.id}>
                 <div className='Mamuriyat__card'>
                   <img src={TeachImg} alt="" className='img' />
                  <div className='fullname'>{item.firstname}  {item.lastname}<br/>{item.middlename}</div>
                  <div className='position'>{item.position}</div>
                  <div className='social'>
                    <img src={FacebookImg} alt=""   className='teachicon' />
                    <img src={InstagramImg} alt=""  className='teachicon' />
                    <img src={Telegramimg} alt=""   className='teachicon'/>
                  </div>
                 </div></Link>
               )
             })
           }
          </div>
     

     <div className='Teachers'>
          <div className='name'>
          <div className="line5"></div>
          <p className='title'>O'qituvchilar</p>
          </div>
    <div className='Teachers__box'>
      {
        teach.map((item,index)=>{
          return(
            <div className='teacher' key={item.id}>
              <img src={Techimg}  className='techimg' alt="" />
              <div className='teacher__infoss'>
                 <div className='fullname'>{item.firstname}  {item.lastname}<br/>{item.middlename}</div>
                 <div className='position'>{item.position}</div>
                 <div className='description'>Oliy toifali matematika o’qituvchisi. 2004-yilda O’zMUning “Amaliy matematika” fakultetini tamomlagan. 2006-yilda SamDUning matematikani... 
                 <Link to={`/teacher/${item.id}`}><span className='batafsil'> Batafsil o’qish</span></Link>
                 </div>
              </div>
            </div>
          )
        })
      }
    </div>
    <button className='view'>Ko'proq ko'rish</button>
          
       </div>
      
       </div>
       
    </div>
  )
}
export default Tuzilma
